import { REQUEST, CANCELABLE_REQUEST } from '@/constants';
import moment from 'moment-timezone';

export const GOOGLE_CALENDAR_STATUS_FETCH = 'GOOGLE_CALENDAR_STATUS_FETCH';
export const GOOGLE_CALENDAR_STATUS_SET = 'GOOGLE_CALENDAR_STATUS_SET';
export const GOOGLE_CALENDAR_CONNECT = 'GOOGLE_CALENDAR_CONNECT';
export const GOOGLE_CALENDAR_DISCONNECT = 'GOOGLE_CALENDAR_DISCONNECT';
export const GOOGLE_CALENDAR_CALENDARS_FETCH = 'GOOGLE_CALENDAR_CALENDARS_FETCH';
export const GOOGLE_CALENDAR_SELECT = 'GOOGLE_CALENDAR_SELECT';
export const GOOGLE_CALENDAR_EVENTS_FETCH = 'GOOGLE_CALENDAR_EVENTS_FETCH';
export const GOOGLE_CALENDAR_EVENTS_SET = 'GOOGLE_CALENDAR_EVENTS_SET';

const localizeDateTimes =
    (timezone) =>
    ({ start_time, end_time }) => {
        timezone = timezone || moment.tz.guess();
        return {
            date: moment.utc(start_time).tz(timezone).startOf('day'),
            startTime: moment.utc(start_time).tz(timezone),
            endTime: moment.utc(end_time).tz(timezone),
        };
    };

export default {
    state: {
        status: { connected: false, calendar_name: null, google_calendar_id: null },
        events: [],
    },
    mutations: {
        [GOOGLE_CALENDAR_STATUS_SET](state, status) {
            state.status = status;
        },
        [GOOGLE_CALENDAR_EVENTS_SET](state, events) {
            state.events = events;
        },
    },
    actions: {
        async [GOOGLE_CALENDAR_STATUS_FETCH]({ commit, dispatch }) {
            const res = await dispatch(REQUEST, { url: 'google-calendar/status' });
            if (res && res.status === 200) {
                commit(GOOGLE_CALENDAR_STATUS_SET, res.data.data);
            }
        },
        async [GOOGLE_CALENDAR_CONNECT]({ dispatch }) {
            const res = await dispatch(REQUEST, { url: 'google-calendar/connect' });
            if (res && res.status === 200) {
                window.location.href = res.data.data.url;
            }
        },
        async [GOOGLE_CALENDAR_DISCONNECT]({ commit, dispatch }) {
            const res = await dispatch(REQUEST, {
                method: 'delete',
                url: 'google-calendar/disconnect',
            });
            if (res && res.status === 200) {
                commit(GOOGLE_CALENDAR_STATUS_SET, {
                    connected: false,
                    calendar_name: null,
                    google_calendar_id: null,
                });
                commit(GOOGLE_CALENDAR_EVENTS_SET, []);
            }
        },
        async [GOOGLE_CALENDAR_CALENDARS_FETCH]({ dispatch }) {
            const res = await dispatch(REQUEST, { url: 'google-calendar/calendars' });
            return res && res.status === 200 ? res.data.data : [];
        },
        async [GOOGLE_CALENDAR_SELECT]({ commit, dispatch }, payload) {
            const res = await dispatch(REQUEST, {
                method: 'post',
                url: 'google-calendar/select',
                data: payload,
            });
            if (res && res.status === 200) {
                commit(GOOGLE_CALENDAR_STATUS_SET, {
                    connected: true,
                    calendar_name: payload.google_calendar_name,
                    google_calendar_id: payload.google_calendar_id,
                });
            }
        },
        async [GOOGLE_CALENDAR_EVENTS_FETCH]({ commit, dispatch, rootState }, params) {
            const res = await dispatch(CANCELABLE_REQUEST, {
                url: 'google-calendar/events',
                params,
            });
            if (res && res.status === 200 && Array.isArray(res.data?.data)) {
                const events = res.data.data
                    .filter((e) => !e.all_day)
                    .map((event) => ({
                        ...event,
                        ...localizeDateTimes(rootState.profile?.user?.timezone)(event),
                        type: 'google',
                        source: 'google_calendar',
                        read_only: true,
                    }));
                commit(GOOGLE_CALENDAR_EVENTS_SET, events);
            }
            if (res && res.status === 401) {
                commit(GOOGLE_CALENDAR_STATUS_SET, {
                    connected: false,
                    calendar_name: null,
                    google_calendar_id: null,
                });
                commit(GOOGLE_CALENDAR_EVENTS_SET, []);
            }
        },
    },
};
